import React from "react"
import Navbar from "../../../Common/Components/Navbar"
import Footer from "../../../Common/Components/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import ViewTransactionComp  from "./Component/ViewTransactionComp"

const ViewTransaction =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <ViewTransactionComp />
        </div>
        <Footer />
        </>
    )
}

export default ViewTransaction